import { useState, useEffect } from 'react'
import { getEjipFundStatusAPI } from '../services/ejip'

function UseEjipStatus() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getEjipFundStatusAPI()
      if (!result) return

      const newData = result.result.map((d, i) => {
        return { value: d.id, label: d.status }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseEjipStatus
